import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

const Deposit = ({ isUserLoggedIn, feed, className }) => {
    const destination = (isUserLoggedIn) ? 'top-up' : 'login'
    return (
        <Link
            to={`/${feed}/${destination}`}
            className={classNames(`
                        bs-btn
                        bs-btn_default
                        bs-btn_link
                        bs-actionBar__button
                        bs-actionBar__button_2XL
                        bs-betForm__button
                        `,
                        className,
                    )}
        >
            <span className="bs-btn__content_multiline">
                <span className="bs-betForm__buttonLine">
                    Deposit
                </span>
            </span>
        </Link>
    );
};

Deposit.defaultProps = {
    isUserLoggedIn: false,
    className: '',
};

Deposit.propTypes = {
    isUserLoggedIn: PropTypes.bool,
    feed: PropTypes.string.isRequired,
    className: PropTypes.string,
};

export default Deposit;



// WEBPACK FOOTER //
// /src/js/common/deposit/Deposit.jsx